import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { uploadMessageAttachment } from '../../../../services/messageService';

export interface Attachment {
  name: string;
  url: string;
  mimetype: string;
}

export function useMessageAttachments() {
  const { t } = useTranslation();
  const [attachments, setAttachments] = useState<Attachment[]>([]);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const upload = async (file: File) => {
    setUploading(true);
    setError(null);
    try {
      const allowedTypes = [
        'application/pdf',
        'image/jpeg',
        'image/png',
        'image/jpg',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ];
      const maxSizeMB = Number(process.env.REACT_APP_MAX_FILE_SIZE_MB) || 5;
      console.log(maxSizeMB)
      if (!allowedTypes.includes(file.type)) {
        setError(t('unsupported_file_type'));
        setUploading(false);
        return;
      }
      if (file.size / 1024 / 1024 > maxSizeMB) {
        setError(t('file_too_large', { maxSizeMB }));
        setUploading(false);
        return;
      }
      const data = await uploadMessageAttachment(file);
      setAttachments(prev => [...prev, data]);
    } catch (e: any) {
      setError(e.message || t('upload_failed'));
    } finally {
      setUploading(false);
    }
  };

  const remove = (name: string) => {
    setAttachments(prev => prev.filter(att => att.name !== name));
  };

  const clear = () => setAttachments([]);

  return {
    attachments,
    uploading,
    error,
    upload,
    remove,
    clear,
    setError,
  };
}
